import angular from 'angular';
import * as Configuration from '../../app.constants.js';
let moduleName = 'preferences.service';

export class PreferencesService {
  constructor($http) {
    this.$http = $http;
  }
  updateInfo(companyId,data) {
    return this.$http.post(Configuration.constants.baseUrl + 'api/1.0/companies/' + companyId + '/preferences/account', data);
  }
  updatePassword(companyId,data) {
    return this.$http.post(Configuration.constants.baseUrl + 'api/1.0/companies/' + companyId + '/preferences/password',data).then(result => result.data,error => error);
  }

  updateNotifications(companyId,data) {
    return this.$http.post(Configuration.constants.baseUrl + 'api/1.0/companies/' + companyId + '/preferences/notifications',data).then(result => result.data,error => error);
  }

  static PreferencesFactory($http) {
    return new PreferencesService($http);
  }
}
PreferencesService.PreferencesFactory.$inject = ['$http'];

angular
  .module(moduleName, [])
  .factory('PreferencesFactory', PreferencesService.PreferencesFactory);

